module.exports = __webpack_public_path__ + "static/img/soft03.d2bda33c.png";